import { TrafficShare } from "app/components/React/Table/cells/TrafficShare";
import { abbrNumberFilter, minAbbrNumberFilter } from "app/filters/ngFilters";
import { FlexRow, FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled, { css } from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { NOT_AVAILABLE } from "app/filters/const";

const TotalVisitsContainer = styled.div<{ layout: string }>`
    text-align: ${({ layout }) => (layout === "row" ? "left" : "right")};
    min-width: ${({ layout }) => (layout === "row" ? "30px" : "50px")};
`;

const TrafficShareContainer = styled.div<{ layout: string }>`
    margin-left: ${({ layout }) => (layout === "row" ? "20px" : "12px")};
    width: 100%;
    ${({ layout }) =>
        layout === "row" &&
        css`
            width: 80%;
        `};

    .min-value {
        color: ${rgba(colorsPalettes.carbon[500], 0.6)};
    }
`;
interface ITrafficShareWithVisits {
    layout?: "row" | "column";
    totalVisitsRowProp?: string;
    totalVisitsFilter?: any;
    applyAbbrNumberFilter?: boolean;
    row: any;
    value: any;
    shareMinThreshold?: number;
    visitMinThreshold?: number;
    thresholdForTotalFilter?: number;
    displayLessThanThreshold?: boolean;
    thresholdTrafficShareWithVisitsPercentage?: number;
    undefinedSign?: string;
    innerColor?: string;
    isPreviousPeriod?: boolean;
    hideTotalVisits?: boolean;
    minPercentageToShow?: number;
}

export const TrafficShareWithVisits = (props: ITrafficShareWithVisits) => {
    const {
        layout = "column",
        applyAbbrNumberFilter = false,
        totalVisitsRowProp = "TotalVisits",
        totalVisitsFilter = abbrNumberFilter,
        shareMinThreshold = 0,
        visitMinThreshold,
        thresholdForTotalFilter = 5000,
        displayLessThanThreshold,
        thresholdTrafficShareWithVisitsPercentage,
        undefinedSign = NOT_AVAILABLE,
        isPreviousPeriod,
        hideTotalVisits = false,
    } = props;
    const trafficShareHeight = layout === "column" ? 4 : 8;
    let totalVisits = applyAbbrNumberFilter
        ? minAbbrNumberFilter()(props.row[totalVisitsRowProp], thresholdForTotalFilter)
        : totalVisitsFilter()(props.row[totalVisitsRowProp]);
    if (!props.value || (props.row.Clicks === 0 && displayLessThanThreshold)) {
        return (
            <FlexRowFlexEnd>{displayLessThanThreshold ? `< ${thresholdForTotalFilter}` : undefinedSign}</FlexRowFlexEnd>
        );
    }

    if (visitMinThreshold !== null && visitMinThreshold !== undefined) {
        totalVisits = !applyAbbrNumberFilter && props.row[totalVisitsRowProp] <= visitMinThreshold ? "-" : totalVisits;
    } else {
        totalVisits = !applyAbbrNumberFilter && props.value < 0.0001 ? "-" : totalVisits;
    }
    return (
        <FlexRow
            justifyContent="flex-start"
            alignItems="center"
        >
            {!hideTotalVisits ? <TotalVisitsContainer layout={layout}>{totalVisits}</TotalVisitsContainer> : null}
            {shareMinThreshold <= props.row[totalVisitsRowProp] ? (
                <TrafficShareContainer
                    layout={layout}
                    style={hideTotalVisits ? { marginLeft: 0 } : {}}
                >
                    <TrafficShare
                        {...(props as any)}
                        thresholdTrafficShareWithVisitsPercentage={thresholdTrafficShareWithVisitsPercentage}
                        layout={layout}
                        height={trafficShareHeight}
                        isPreviousPeriod={isPreviousPeriod}
                    />
                </TrafficShareContainer>
            ) : null}
        </FlexRow>
    );
};

TrafficShareWithVisits.displayName = "TrafficShareWithVisits";
